import moment from 'moment-timezone';
import { DEFAULT_WEEK_START, DEFAULT_LANGUAGE, WEEK_LENGTH } from '@wix/wix-events-commons-statics';
import { getWeekday } from './formatter';
export { moment };
export var now = function (timeZoneId) { return moment.tz(timeZoneId); };
export var getMomentDate = function (date, timeZoneId) { return moment.tz(date, timeZoneId); };
export var getUtcOffset = function (date, timeZoneId) {
    return getMomentDate(date, timeZoneId).utcOffset();
};
export var getDurationInHours = function (end, start) { return moment.duration(end.diff(start)).asHours(); };
export var getDurationInMinutes = function (end, start) { return moment.duration(end.diff(start)).asMinutes(); };
export var getDurationInMilliseconds = function (end, start) {
    return moment.duration(end.diff(start)).asMilliseconds();
};
export var getDiffInHours = getDurationInHours;
export var getWeekDayNames = function (locale, weekStartDay) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    if (weekStartDay === void 0) { weekStartDay = DEFAULT_WEEK_START; }
    var weekDates = [moment().startOf('week')];
    for (var i = 1; i < WEEK_LENGTH; i++) {
        weekDates.push(weekDates[weekDates.length - 1].clone().add(1, 'day'));
    }
    var weekDayNames = weekDates.reduce(function (names, date) {
        names.push(new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date.toDate()));
        return names;
    }, []);
    // Rotate week to start as needed.
    var endOfWeek = weekDayNames.splice(0, weekStartDay);
    endOfWeek.forEach(function (day) { return weekDayNames.push(day); });
    return weekDayNames;
};
export var getTimeText = function (date, locale) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    var intl = new Intl.DateTimeFormat(locale, { hour: '2-digit', minute: '2-digit' });
    return intl.format(date);
};
export var getFullMonthText = function (date, locale, timeZone) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    var intl = new Intl.DateTimeFormat(locale, { year: 'numeric', month: 'long', timeZone: timeZone });
    return intl.format(date);
};
export var getDayMonthText = function (date, locale, timeZone) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    var intl = new Intl.DateTimeFormat(locale, { day: 'numeric', month: 'long', timeZone: timeZone });
    return intl.format(date);
};
export var getWeekdayLabel = function (weekday, locale) {
    if (locale === void 0) { locale = DEFAULT_LANGUAGE; }
    var date = new Date('2017-01-03T00:00:00');
    date.setDate(1 + weekday);
    return getWeekday(date, locale);
};
//# sourceMappingURL=date.js.map